(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initActiveSlideTracking(container) {
      var carousel = container.querySelector('.resource-list__carousel');
      if (!carousel) return;
      var track = carousel.querySelector('slideshow-slides');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.resource-list__slide'));
      if (!slides.length) return;
    
      var ticking = false;

      function updateActiveSlide() {
        ticking = false;
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var closest = null;
        var closestDistance = Infinity;

        slides.forEach(function (slide) {
          var rect = slide.getBoundingClientRect();
          var slideCenter = rect.left + rect.width / 2;
          var distance = Math.abs(slideCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = slide;
          }
        });

        slides.forEach(function (slide) {
          slide.classList.toggle('product-list__slide--active', slide === closest);
        });
      }

      function requestUpdate() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateActiveSlide);
        }
      }

      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      requestUpdate();
    }

    function initAll() {
      document.querySelectorAll('[data-testid="product-list"]').forEach(initActiveSlideTracking);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelectorAll) {
        Array.prototype.forEach.call(
          event.target.querySelectorAll('[data-testid="product-list"]'),
          initActiveSlideTracking
        );
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
